import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocPolicies(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.528 98.75h54.274c4.282 0 7.754-3.352 7.754-7.486H37.28c0 4.134-3.471 7.486-7.753 7.486Z"
        fill="#CCD5E1"
      />
      <path
        d="M68.028 21.75H13.753C9.472 21.75 6 25.102 6 29.236h54.274c0-4.134 3.472-7.486 7.754-7.486Z"
        fill="#E2E8F0"
      />
      <path
        d="M21.329 91.05c0 4.253 3.511 7.7 7.842 7.7H84.07c-4.331 0-7.842-3.447-7.842-7.7v-61.6c0-4.253-3.511-7.7-7.843-7.7H13.486c4.331 0 7.843 3.447 7.843 7.7v61.6Z"
        fill="#F1F5F9"
      />
      <path
        d="M21.242 91.264v-61.79c0-3.75-3.394-6.924-7.756-6.924a.8.8 0 1 1 0-1.6c5.088 0 9.355 3.741 9.356 8.524v61.79a.8.8 0 0 1-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M68.028 76.561a.8.8 0 0 1 0 1.6H41.292a.8.8 0 1 1 0-1.6h26.736Zm0-6.203a.8.8 0 0 1 0 1.6H41.292a.8.8 0 0 1 0-1.6h26.736Zm0-6.202a.8.8 0 0 1 0 1.6H41.292a.8.8 0 1 1 0-1.6h26.736Zm0-6.203a.8.8 0 0 1 0 1.6H41.292a.8.8 0 1 1 0-1.6h26.736Zm0-6.203a.8.8 0 0 1 0 1.6H41.292a.8.8 0 0 1 0-1.6h26.736Zm0-6.203a.8.8 0 0 1 0 1.6H41.292a.8.8 0 1 1 0-1.6h26.736Z"
        fill="#B3C0D0"
      />
      <path
        d="M35.263 49.02c0-.272-.041-.535-.112-.786l-2.33 2.293a.8.8 0 0 1-1.121 0l-.95-.936a.8.8 0 0 1 1.122-1.14l.388.382 2.019-1.987a3.017 3.017 0 0 0-2.018-.768c-1.67 0-3.003 1.33-3.003 2.943s1.333 2.943 3.003 2.943c1.67 0 3.002-1.33 3.002-2.943Zm1.6 0c0 2.522-2.072 4.544-4.602 4.544-2.53 0-4.602-2.022-4.602-4.543 0-2.52 2.072-4.543 4.602-4.543 1.221 0 2.335.472 3.161 1.243l1.03-1.013a.8.8 0 0 1 1.124 1.14l-1.186 1.166c.302.604.474 1.285.474 2.007ZM35.263 61.854c0-.272-.041-.536-.112-.787l-2.33 2.293a.8.8 0 0 1-1.121 0l-.95-.935a.8.8 0 0 1 1.122-1.141l.388.383 2.019-1.988a3.017 3.017 0 0 0-2.018-.768c-1.67 0-3.003 1.33-3.003 2.943 0 1.614 1.333 2.944 3.003 2.944 1.67 0 3.002-1.33 3.002-2.944Zm1.6 0c0 2.521-2.072 4.543-4.602 4.543-2.53 0-4.602-2.022-4.602-4.543 0-2.52 2.072-4.543 4.602-4.543 1.221 0 2.335.472 3.161 1.243l1.03-1.013a.8.8 0 0 1 1.124 1.14l-1.186 1.166c.302.605.474 1.285.474 2.007ZM35.263 74.688c0-.273-.041-.536-.112-.788l-2.33 2.293a.8.8 0 0 1-1.121 0l-.95-.935a.8.8 0 0 1 1.122-1.14l.388.382 2.019-1.987a3.017 3.017 0 0 0-2.018-.769c-1.67 0-3.003 1.33-3.003 2.944 0 1.613 1.333 2.943 3.003 2.943 1.67 0 3.002-1.33 3.002-2.943Zm1.6 0c0 2.52-2.072 4.543-4.602 4.543-2.53 0-4.602-2.023-4.602-4.543 0-2.521 2.072-4.543 4.602-4.543 1.221 0 2.335.472 3.161 1.243l1.03-1.014a.8.8 0 0 1 1.124 1.14l-1.186 1.167c.302.604.474 1.285.474 2.007Z"
        fill="#78B441"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.666 71.86a1.955 1.955 0 0 1 2.394 1.382l2.441 9.122a1.955 1.955 0 0 1-1.888 2.46h-43.08a1.955 1.955 0 0 1 0-3.91h40.533l-1.783-6.661a1.955 1.955 0 0 1 1.383-2.394Z"
        fill="#5BBDA0"
      />
      <path d="M70.08 73.748h39.093l-4.561 7.819H65.519l4.56-7.82Z" fill="#F1F5F9" />
      <path
        d="M92.885 78.16a.8.8 0 0 1 0 1.6H73.338a.8.8 0 1 1 0-1.6h19.547Zm9.773 0a.8.8 0 0 1 0 1.6h-4.887a.8.8 0 1 1 0-1.6h4.887Z"
        fill="#0F172A"
      />
      <path
        d="M60.102 36.61c-.695 0-1.338.368-1.689.969l-6.461 11.076c-.263.45-.335.987-.2 1.49l8.893 33.23a1.955 1.955 0 0 0 3.577.48l5.896-10.107h41.011a1.954 1.954 0 0 0 1.888-2.46l-8.893-33.23a1.955 1.955 0 0 0-1.888-1.449h-38.02c-.68 0-1.279.347-1.629.874a1.953 1.953 0 0 0-1.629-.874h-.856Z"
        fill="#599F40"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.453 36.676a1.955 1.955 0 0 1 2.393 1.383l8.506 31.78h39.776a1.955 1.955 0 1 1 0 3.909h-41.01L64.22 83.855a1.955 1.955 0 0 1-3.376-1.97l6.461-11.077c.056-.094.118-.183.187-.266L59.07 39.069a1.955 1.955 0 0 1 1.383-2.393Z"
        fill="#78B441"
      />
      <path
        d="m70.07 54.178-4.702-17.569h9.122l4.657 17.404c.169.628-.586 1.088-1.067.65l-4.09-3.72-2.274 3.496a.912.912 0 0 1-1.646-.261Z"
        fill="#FC0"
      />
      <path d="M107.653 75.12a.8.8 0 1 1 0 1.6H71.817a.8.8 0 1 1 0-1.6h35.836Z" fill="#0F172A" />
    </svg>
  )
}
export default wrapIllustration(SvgDocPolicies)
